<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        휴/복직신청
      </v-col>
    </v-row>
    <!-- 휴직기간-->
    <div class="d-flex justify-center">
      <v-card class="cont-area">
        <v-card-title class="cont-title"
          ><div class="title">휴직기간</div>
        </v-card-title>
        <v-card-text class="date"
          >{{ GET_S_YMD }} ~ {{ GET_E_YMD }}&nbsp;/&nbsp;{{
            period
          }}일</v-card-text
        >
        <v-card-text class="text"
          >복직예정일은 <span>{{ reInDate }}</span
          >입니다.</v-card-text
        >
      </v-card>
    </div>
    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field label="휴직사유" v-model="refReason"></v-text-field>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg/
import routerNames from '@/const/routerConstants';
import { getLeaAbsEtcAppDetApplYn, getLeaAbsAppDetApplLvlCode } from '@/api/workStatus';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';

export default {
  data: () => ({
    reInDate: '',
    period: '',
    famNm: '',
    birthDay: '',
    refReason: '',
    fileFlag: false,
    fileShow: true,
  }),

  components: {
    IconApprovalDoc,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
  },

  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
      'GET_ORG_LEVEL'
    ]),
    ...mapGetters([
      'GET_APPL_CD',
      'GET_CODE',
      'GET_CODE1',
      'GET_BIRTHDAY',
      'GET_CODE_NM',
      'GET_USER_DATA',
      'GET_LIMIT_TERM',
      'GET_FAM_SEQ',
      'GET_FILE_SEQ',
      'GET_PARAMS',
    ]),
  },

  methods: {
    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },

    async applovalPage() {
      if (this.refReason.trim() === '') {
        alert('휴직사유를 입력해 주세요');
        return;
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '') {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      if ( this.GET_ELA_APPL_PARAM.searchApplCd === "154" ){ // 난임

        let params = {
          refSdate: this.GET_S_YMD,
          refEdate: this.GET_E_YMD,
        }

        let response = await getLeaAbsEtcAppDetApplYn(params);

				  if ( response != null && response.data.data != null ){
						if( response.data.data.appl154Yn === "N" ){
							alert("난임치료휴직은 재직기간중 최대 2회만 가능합니다.");
							return;
						}

						if ( response.data.data.btChk === "N" ){
							alert("난임치료휴직은 1회 신청시\r\n신청기간은 3개월 고정 입니다.");
							return;
						}
					}
				} else if ( this.GET_ELA_APPL_PARAM.searchApplCd === "159" ){ //신상휴직

          let params = {
            refSdate: this.GET_S_YMD,
            refEdate: this.GET_E_YMD,
          }

          let response = await getLeaAbsEtcAppDetApplYn(params);

					if ( response != null && response.data.data != null ){

						if ( response.data.data.btChk159 === "N" ){
							alert("신청기간이 초과되었습니다. \r\n신청기간은 최대 3개월 입니다.");
							return;
						}
					}
				}

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        applTypeCd: '10', //본인신청
        refSdate: this.GET_S_YMD,
        refEdate: this.GET_E_YMD,
        returnYmd: this.reInDate,
        //famCd: this.GET_CODE1,
        //famNm: this.GET_CODE_NM,
        //famSeq: this.GET_FAM_SEQ,
        refReason: this.refReason,
        remainDaysBefore: this.GET_LIMIT_TERM,
        //usedDaysBefore: this.GET_LIMIT_TERM - this.period, 현재는 사용하지 않음
        caDays: this.period,
        applCd: this.GET_APPL_CD,
      };

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_LEAABS_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },

    addDate(pInterval, pAddVal, pYyyymmdd, pDelimiter) {
      var yyyy;
      var mm;
      var dd;
      var cDate;
      var cYear, cMonth, cDay;

      if (pYyyymmdd == '') {
        return '';
      }

      if (pDelimiter != '') {
        pYyyymmdd = pYyyymmdd.replace(eval('/\\' + pDelimiter + '/g'), '');
      }

      yyyy = pYyyymmdd.substr(0, 4);
      mm = pYyyymmdd.substr(4, 2);
      dd = pYyyymmdd.substr(6, 2);

      if (pInterval == 'yyyy') {
        yyyy = yyyy * 1 + pAddVal * 1;
      } else if (pInterval == 'm') {
        mm = mm * 1 + pAddVal * 1;
      } else if (pInterval == 'd') {
        dd = dd * 1 + pAddVal * 1;
      }

      cDate = new Date(yyyy, mm - 1, dd); // 12월, 31일을 초과하는 입력값에 대해 자동으로 계산된 날짜가 만들어짐.
      cYear = cDate.getFullYear();
      cMonth = cDate.getMonth() + 1;
      cDay = cDate.getDate();

      cMonth = cMonth < 10 ? '0' + cMonth : cMonth;
      cDay = cDay < 10 ? '0' + cDay : cDay;

      //if (pDelimiter != "") {
      return cYear + pDelimiter + cMonth + pDelimiter + cDay;
      //} else {
      //	return cYear + cMonth + cDay;
      //}
    },
  },

  async mounted() {
    this.reInDate = this.addDate('d', 1, this.GET_E_YMD, '-');

    const oldDate = new Date(this.GET_S_YMD);
    const newDate = new Date(this.GET_E_YMD);
    let diff = Math.abs(newDate.getTime() - oldDate.getTime());
    diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

    this.period = diff + 1;

    this.famNm = this.GET_CODE_NM;
    this.birthDay = this.GET_BIRTHDAY;

    this.refReason =
      this.GET_PARAMS.refReason === undefined ? '' : this.GET_PARAMS.refReason;

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }

    let params = {
      searchApplYmd: dayjs().format('YYYYMMDD'),
    }

    let response = await getLeaAbsAppDetApplLvlCode(params);

    if (response.data.data !== null) {
      if(response.data.data.levCode !== undefined) {
        this.$store.commit('ELA/SET_ORG_LVL', response.data.data.levCode);
      }
    }
  },
};
</script>

<style></style>
